var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkflowsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#8B909A",
    strokeWidth: 0.85,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2.727v8.864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.783,
    width: 10.435,
    height: 2.727,
    rx: 0.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.261,
    y: 11.591,
    width: 3.478,
    height: 3.409,
    rx: 0.696
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.591,
    width: 3.478,
    height: 3.409,
    rx: 0.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.522,
    y: 11.591,
    width: 3.478,
    height: 3.409,
    rx: 0.696
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.913 11.592v-3.41a.689.689 0 0 0-.696-.681H2.783a.689.689 0 0 0-.696.681v3.41"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowsIcon);
export default __webpack_public_path__ + "static/media/workflows-icon.74710283.svg";
export { ForwardRef as ReactComponent };